"use client";

// import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  // const { theme = "system" } = useTheme();

  return (
    <Sonner
      // theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        className: "border",
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border border-white/5 border-2",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-green group-[.toast]:text-black",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton:
            "group-[.toast]:bg-card-bg group-[.toast]:text-gray-p  group-[.toast]:hover:bg-card group-[.toast]:hover:border-white/5 group-[.toast]:border-white/5",
        },
        closeButton: true,
      }}
      position="top-center"
      {...props}
    />
  );
};

export { Toaster };
